export const SECTOR_OPTIONS = Object.freeze([
  "Agriculture, Forestry & Fishing",
  "Mining & Natural Resources",
  "Manufacturing",
  "Food & Beverage Manufacturing",
  "Energy & Utilities",
  "Water, Waste & Environmental Services",
  "Construction & Infrastructure",
  "Wholesale & Distribution",
  "Retail & Consumer Services",
  "Transportation, Logistics & Warehousing",
  "Hospitality, Tourism & Food Services",
  "Technology, Software & Digital Services",
  "Media & Telecommunications",
  "Financial Services, Banking & Insurance",
  "Real Estate",
  "Professional & Business Services",
  "Education & Training",
  "Healthcare & Social Services",
  "Arts, Entertainment, Sports & Recreation",
  "Personal & Other Services",
  "Public Sector & Non-profit Organizations",
]);
